import {StyleSelectors} from '../../style-selectors'
import {useVisibilityStylesBuilder} from '../../../../commons/hooks/use-visibility-styles-builder'

export const useVisibilityStyles = () => useVisibilityStylesBuilder(StyleSelectors)
